module.exports = __webpack_public_path__ + "img/图.8d78f09f.webp";